export const getFileProperties = (url: URL) => {
  const name = url.pathname.split('/').pop()!;
  const source = url.hostname;

  let extension = undefined;
  if (name.includes('.')) {
    extension = name.split('.').pop()!.toLowerCase();
  }

  return { extension, name, source };
};
